import { Neutral } from 'glints-aries/es/@next/utilities/colors';
import styled from 'styled-components';

export const Container = styled.div`
  max-width: 620px;
  color: ${Neutral.B18};
`;
